import { useNNEvidences } from "@/api/nn-evidence";
import { FieldCheckbox } from "@/components/form/field-checkbox";
import { FieldRadio } from "@/components/form/field-radio";
import { FieldTextarea } from "@/components/form/field-textarea";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { MISSING_ID_IN_ROUTE, ROLE } from "@/utils/constant";
import { hasCommonElement } from "@/utils/helper/hasCommonElement";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

const decisionOptions = [
  {
    value: "yes",
    label: "Approve",
  },
  {
    value: "no",
    label: "Reject",
  },
  {
    value: "cancel",
    label: "Cancel",
  },
];

const defaultDecision = [
  {
    value: "yes",
    label: "Approve",
  },
  {
    value: "no",
    label: "Reject",
  },
];

export function ApprovalSection() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }
  const { data: nnEvidences } = useNNEvidences({ rfsId: id });

  const form = useFormContext();
  const decision = form.watch("decision");

  const { roles } = useCurrentUser();
  const isAllowed = hasCommonElement(roles, [
    ROLE.ADMINISTRATOR,
    ROLE.REVISE_DOCUMENT_OFFICER,
    ROLE.VALIDATOR_DOCUMENT_OFFICER,
  ]);
  const isAdmin = roles.includes(ROLE.ADMINISTRATOR);

  const nnEvidence = nnEvidences?.[0];
  const showDummyHouseNumbersAlert =
    nnEvidence?.valid && nnEvidence?.documentNnEvidencePath == null;
  const optionsDisable = showDummyHouseNumbersAlert ? ["nnEvidence"] : [];

  if (!isAllowed) {
    return null;
  }

  return (
    <>
      <FieldRadio
        name="decision"
        label="Status Document"
        options={isAdmin ? decisionOptions : defaultDecision}
        hasRequiredAsterisk
      />
      {decision === "no" && (
        <>
          <FieldCheckbox
            name="problematicDocuments"
            label="Review & Validation Document"
            hasRequiredAsterisk
            description="Please check if documents are appropriate"
            optionsDisable={optionsDisable}
            options={[
              {
                value: "opm",
                label: "OPM",
              },
              {
                value: "evidenceNn",
                label: "Evidence NN",
              },
              {
                value: "hptar",
                label: "HPTAR",
              },
              {
                value: "gpon",
                label: "GPON",
              },
              {
                value: "abdFromKmz",
                label: "ABD from KMZ (pdf)",
              },
              {
                value: "abdFromDwg",
                label: "ABD from DWG (pdf)",
              },
              {
                value: "abd",
                label: "ABD (dwg)",
              },
              {
                value: "evidenceFeeder",
                label: "Evidence New Homepass",
              },
              {
                value: "bakp",
                label: "BAKP (pdf)",
              },
              {
                value: "cmld",
                label: "CMLD (pdf)",
              },
              {
                value: "clampHook",
                label: "Others (zip)",
              },
              {
                value: "evidenceOlt",
                label: "Evidence All Homepass",
              },
            ]}
            containerClassName="flex flex-col gap-y-2 md:max-h-24 flex-wrap"
          />
        </>
      )}
      {(decision === "no" || decision === "cancel") && (
        <FieldTextarea name="notes" label="Notes" hasRequiredAsterisk />
      )}
    </>
  );
}
